import { useEffect, useReducer } from 'react';
import { types } from '../Types/types';
import { AuthContext } from './AuthContext';
import { authReducer } from './authReducer';
import { requestGet } from '../../Helpers';
import { useChekingAuth } from '../Hooks/useChekingAuth';

const initialState = {
    logged: false,
    user: {},
}

const init = async () => {

    const token = JSON.parse(localStorage.getItem('user_store_ecommerce'));

    if (!token) {
        return {
            logged: false,
            user: {}
        }
    }

    const user = await requestGet(`login/?token=${token}`)
        .then((resp) => {
            
            if (typeof resp === 'object') {
                const {name, email, is_superuser, is_staff, is_active} = resp.user;

                return {
                    nombres: name,
                    correo: email,
                    is_superuser,
                    is_staff,
                    is_active,
                    token
                }
            } 
            
            return {
                logged: false,
                user: {}    
            };
        })
        .catch((error) => {
            new Error(error);
        })
    
    if (!user) {
        return {
            logged: false,
            user: {}
        }
    }

    return {
        logged: !!user,
        user,
    }
}

export const AuthProvider = ({children}) => {

    const [authState, dispatch] = useReducer(authReducer, initialState);
    const { logged } = useChekingAuth();

    useEffect(() => {
        // init()
        //     .then((resp) => {
        //         console.log('resp', resp);
        //         if (!resp.logged) {
        //             return;
        //         }
        //         dispatch({
        //             type: types.login,
        //             payload: resp.user
        //         })
        //     })

        if (logged?.logged) {
            dispatch({
                type: types.login,
                payload: logged.user
            })
        }

    }, [logged])

    const login = ( nombres, correo = '', is_superuser = false, is_staff = false, is_active = true, token) => {

        const user = {
            // id: id,
            nombres,
            correo,
            is_superuser,
            is_staff,
            is_active,
            token
        }

        const action = {
            type: types.login,
            payload: user
        }

        localStorage.setItem('user_store_ecommerce', JSON.stringify(token));
        dispatch(action);
    }

    const logout = () => {
        localStorage.removeItem('user_store_ecommerce');
        dispatch({
            type: types.logout
        });
    }

    return (
        <AuthContext.Provider
            value={{
                ...authState,
                login,
                logout
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}
